import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ImageFile } from "@shared/models/file-manager/image-file";

@Component({
  selector: 'app-closable-image-chip',
  templateUrl: './closable-image-chip.component.html',
  styleUrls: ['./closable-image-chip.component.css']
})
export class ClosableImageChipComponent  {
  @Output () onDelete = new EventEmitter<string>();
  @Input() imageFile!: ImageFile

  constructor(
  ) {}

  remove() {
    this.onDelete.emit(this.imageFile.id);
  }
}
